import plural from 'plural-ru';

export function usePlural (value, strings) {
    const returnString = plural(value, strings[0], strings[1], strings[2]);

    return returnString;
}
